module.exports = __webpack_public_path__ + "static/img/hover2.e22ac22e.png";